import { Cache } from '@aws-amplify/cache';

/**
 * Clears authentication-related cache entries while preserving application-specific keys.
 * This removes Cognito and AWS Amplify cache keys that can cause stale auth state issues.
 */
export const clearAuthCache = () => {
    // Clear Amplify federatedInfo cache
    Cache.removeItem('federatedInfo');

    // Clear localStorage auth-related keys - but preserve refresh tokens
    Object.keys(localStorage).forEach((key) => {
        if (
            (key.includes('CognitoIdentityServiceProvider') &&
                (key.endsWith('.accessToken') || key.endsWith('.idToken'))) ||
            key.startsWith('aws-amplify-cache')
        ) {
            localStorage.removeItem(key);
        }
    });
};
